module.exports = __webpack_public_path__ + "static/media/signIcon.ed229c69.svg";